import type {
  Control,
  UseFormGetValues,
  UseFormSetValue,
} from "react-hook-form";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/Endpoint";
import type { IFilterRider } from "../../types/interface";
import { classNames } from "../../utils/classNames";
import ComboboxFilter from "../Reusable/ComboboxFilter";
import DateRangePicker from "../Reusable/DateRangerPicker";
import MultiSelectFilter from "../Reusable/MultiSelectFilter";

interface Props {
  setValue: UseFormSetValue<IFilterRider>;
  getValues: UseFormGetValues<IFilterRider>;
  handleFilterReset: () => void;
  control: Control<IFilterRider, any>;
  isFilterVisible: boolean;
}

const RiderFilter = ({
  setValue,
  getValues,
  handleFilterReset,
  control,
  isFilterVisible,
}: Props) => {
  return (
    <>
      <div
        className={classNames(
          isFilterVisible ? tw`block` : tw`hidden`,
          tw`relative`
        )}
      >
        {isFilterVisible ? (
          <div className={tw`grid md:grid-cols-3 gap-4`}>
            <DateRangePicker
              label={"Select Date Range"}
              setValue={setValue}
              name={"created__range"}
              getValues={getValues}
            />

            <ComboboxFilter<IFilterRider>
              url={APIS.RIDER}
              queryKey={"driver"}
              control={control}
              name={"driver"}
              label={"Rider"}
              params={{
                is_active: true,
              }}
              placeholder={"Select Rider"}
            />
            <MultiSelectFilter<IFilterRider>
              label={"Status"}
              queryKey={"status__in"}
              params={{
                is_active: true,
              }}
              name={"status__in"}
              control={control}
              url={`${APIS.STATUS}`}
            />
            <button
              className={tw`absolute -top-5 right-5`}
              onClick={handleFilterReset}
            >
              Reset
            </button>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default RiderFilter;
